export const LOGIN_ROUTE = "/login";
export const HOME_ROUTE = "/home";
export const POST_ROUTE = "/post/:param";
export const PROFILE_ME_ROUTE = "/profile";
export const PROFILE_ROUTE = "/profile/:uid";
export const USERS_ROUTE = "/users";
export const FRIENDS_ROUTE = "/friends";
export const DIALOGS_ROUTE = "/dialogs";
export const NEW_DIALOG_ROUTE = "/new-dialog";
export const DIALOG_ROUTE = "/dialog/:id";
export const LIKES_ROUTE = "/likes";
export const MY_POSTS_ROUTE = "/my-posts";

export const REACT_APP_SITE_KEY = "6Ld3MuohAAAAABnmCjb5I5qY_EIF3jUOODvPNkja"